import HTTP from '../../utils/Http'
import * as authActions from './actions'
import { notify } from 'reapop'

export function login(credentials) {
    return (dispatch) => {
        dispatch(authActions.authLoginStart())
        delete HTTP.defaults.headers.common['Authorization']
        HTTP.post('/auth/admin-users/login', credentials)
            .then((res) => {
                console.log(res)
                dispatch(authActions.authLoginSuccess(res.data.success.token))
            })
            .catch((err) => {
                let data = err.response.data.message
                console.log(data)
                if (data === '') {
                    data = 'Error Logging In Please Retry'
                }
                dispatch(authActions.authLoginFail(data))
                // window.setTimeout(() => {
                //   window.location.reload(true);
                // }, 500)
            })
    }
}

export function getUser() {
    return (dispatch) => {
        dispatch(authActions.authGetUserStart())
        HTTP.get('/admin-users/current')
            .then((res) => {
                console.log('IM HEREE', res)
                dispatch(authActions.authGetUserSuccess(res.data.data))
            })
            .catch((err) => {
                dispatch(authActions.authLogout())
                dispatch(authActions.authGetUserFail(err.response.data.message))
            })
    }
}

export function editUser(id, values) {
    return (dispatch) => {
        dispatch(authActions.authLoading())
        HTTP.put('/admin-users/' + id, values)
            .then((res) => {
                dispatch(authActions.authGetUserSuccess(res.data))
                dispatch(
                    notify({
                        message: 'Your profile has been saved',
                        status: 'success',
                    })
                )
            })
            .catch((err) => {
                dispatch(authActions.authGetUserFail(err.response.data.message))
            })
    }
}

export function logout() {
    return (dispatch) => {
        HTTP.post('logout')
            .then((res) => {
                dispatch(authActions.authLogout())
            })
            .catch((err) => {})
    }
}



// WEBPACK FOOTER //
// ./src/system/store/auth/services.js